import { TopConfig } from '../context/ConfigContext';

export const getVehicleServiceConfig = (topConfig: TopConfig) => {
    const { vehicles: vehicleServiceConfig } = topConfig.services;
    const { url } = vehicleServiceConfig;

    if (!url) {
        throw new Error('Vehicle service: Url not defined');
    }

    return vehicleServiceConfig;
};
